export const getYoutubeURL = (youtubeID) =>
  `https://www.youtube.com/embed/${youtubeID}?autoplay=1&mute=1&vq=large&controls=0&disablekb=1&playlist=${youtubeID}&loop=1&rel=0&iv_load_policy=0&modestbranding=1`;

export const getVimeoURL = (vimeoID) =>
  `https://player.vimeo.com/video/${vimeoID}?autoplay=1&loop=1&muted=1&background=1`;
